enum CardioFrequency {
  Rarely = "Rarely",
  Occasionally = "Occasionally",
  Frequently = "Frequently",
}

const cardioQuestion = {
  name: 'cardio',
  title: 'How often do you do cardio-related exercise?',
  description: 'This helps us learn how structured exercise fits into your routine.',
  type: "radiogroup",
  choices: [
    {
      value: CardioFrequency.Rarely,
      text: "<div class='icon-button'><div>🛋️</div><div>Rarely / Never<br /><span class=\"small-text\">I don’t really do any structured cardio workouts or exercise</span></div></div>",
    },
    {
      value: CardioFrequency.Occasionally,
      text: "<div class='icon-button'><div>🚶</div><div>Occasionally<br /><span class=\"small-text\">I stay active here and there, but not on a set schedule</span></div></div>",
    },
    {
      value: CardioFrequency.Frequently,
      text: "<div class='icon-button'><div>💪</div><div>Frequently<br /><span class=\"small-text\">I regularly do cardio, workouts, or other physical activities</span></div></div>",
    },
  ],
  isRequired: true,
};

export {
  CardioFrequency,
  cardioQuestion,
}